import { render, staticRenderFns } from "./CustomAttributesFormItem.vue?vue&type=template&id=5fb12ee6&"
import script from "./CustomAttributesFormItem.vue?vue&type=script&lang=js&"
export * from "./CustomAttributesFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributesFormItem.vue?vue&type=style&index=0&id=5fb12ee6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports